// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessOwnership__questionContainer___vdF4Q{max-width:414px;padding:40px 104px}.BusinessOwnership__questionFormContainer___aqvbd{display:flex;flex-direction:column;width:100%}.BusinessOwnership__questionTitle___IGY5x{color:#444;font-size:16px;font-weight:500;line-height:1.5;margin:0 0 8px 0}.BusinessOwnership__footer___uyj21{margin-top:24px;width:100%;display:flex;justify-content:center}.BusinessOwnership__bannerContainer___OVY2L{margin-bottom:16px}`, "",{"version":3,"sources":["webpack://./src/pages/banking-application/BusinessOwnership.scss"],"names":[],"mappings":"AAEA,8CACE,eAAA,CACA,kBAAA,CAGF,kDACE,YAAA,CACA,qBAAA,CACA,UAAA,CAGF,0CACE,UAAA,CACA,cAAA,CACA,eAAA,CACA,eAAA,CACA,gBAAA,CAGF,mCACE,eAAA,CACA,UAAA,CACA,YAAA,CACA,sBAAA,CAGF,4CACE,kBAAA","sourcesContent":["@use '../../styles/colors' as *;\n\n.questionContainer {\n  max-width: 414px;\n  padding: 40px 104px;\n}\n\n.questionFormContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.questionTitle {\n  color: #444444;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0 0 8px 0;\n}\n\n.footer {\n  margin-top: 24px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.bannerContainer {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-ui-blue-01": `#0083ca`,
	"ui-blue-01": `#0091ea`,
	"ui-blue-02": `#0077b8`,
	"ui-blue-03": `#005b8d`,
	"ui-blue-04": `#005c95`,
	"ui-gray-01": `#333`,
	"ui-gray-02": `#666`,
	"ui-gray-03": `#999`,
	"ui-gray-04": `#ccc`,
	"ui-gray-05": `#eee`,
	"ui-gray-06": `#444`,
	"ui-dropshadow": `rgba(0,0,0,.5)`,
	"ui-background": `#f8f8f8`,
	"ui-white": `#fff`,
	"support-red": `#ef3824`,
	"support-orange": `#ff9000`,
	"support-green": `#72bf44`,
	"support-yellow": `#ffc418`,
	"hover-white": `#f9f9f9`,
	"questionContainer": `BusinessOwnership__questionContainer___vdF4Q`,
	"questionFormContainer": `BusinessOwnership__questionFormContainer___aqvbd`,
	"questionTitle": `BusinessOwnership__questionTitle___IGY5x`,
	"footer": `BusinessOwnership__footer___uyj21`,
	"bannerContainer": `BusinessOwnership__bannerContainer___OVY2L`
};
export default ___CSS_LOADER_EXPORT___;
